import { render, staticRenderFns } from "./OrganizationRequestProcess.vue?vue&type=template&id=9a2ce90e&"
import script from "./OrganizationRequestProcess.vue?vue&type=script&lang=js&"
export * from "./OrganizationRequestProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports